import EditPopup from '../../../app/popup/components/edit/EditPopup';

const EditPopupPage = (): JSX.Element => <EditPopup />;

export default EditPopupPage;
